export default "__VITE_ASSET__qb6dJPQ9__"